/**
 * @param {String} filename
 * @return {String}
 */
export default function getFileExtension(filename) {
  return filename.split('.').pop().toLowerCase();
}
